/* global axios */
import ApiClient from './ApiClient';

class TalkviaInventoryCategoriesAPI extends ApiClient {
  constructor() {
    super('talkvia_inventory_categories', { accountScoped: true });
  }

  create(name) {
    return axios.post(this.url, { talkvia_inventory_category: { name } });
  }
}

export default new TalkviaInventoryCategoriesAPI();
